import Resume from "../../assets/swethang_resume.pdf";
import styles from "./Cta.module.css";
const Cta = () => {
  return (
    <div className={styles.cta}>
      <a href={Resume} download className="btn">
        Download Resume
      </a>
    </div>
  );
};

export default Cta;
